"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var errorType = {
    UNKNOWN_ERROR: 'UNKNOWN_ERROR',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    NETWORK_ERROR: 'NETWORK_ERROR',
    NOT_FOUND: 'NOT_FOUND',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    LOGIN_INVALID_CREDENTIALS: 'LOGIN_INVALID_CREDENTIALS',
    SIGNUP_USER_NOT_REGISTERED: 'SIGNUP_USER_NOT_REGISTERED',
    SIGNUP_USER_ALREADY_ACTIVE: 'SIGNUP_USER_ALREADY_ACTIVE',
    SIGNUP_PENDING_VERIFICATION: 'SIGNUP_PENDING_VERIFICATION',
    SIGNUP_INVALID_VERIFICATION_LINK: 'SIGNUP_INVALID_VERIFICATION_LINK',
    SIGNUP_EXPIRED_VERIFICATION_LINK: 'SIGNUP_EXPIRED_VERIFICATION_LINK',
    RESET_PASSWORD_INVALID_CONTEXT: 'RESET_PASSWORD_INVALID_CONTEXT',
    RESET_PASSWORD_EXPIRED_LINK: 'RESET_PASSWORD_EXPIRED_LINK',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    UNAUTHORIZED: 'UNAUTHORIZED',
    SEARCH_INCORRECT_PARAMS: 'SEARCH_INCORRECT_PARAMS',
};
exports.default = errorType;
//# sourceMappingURL=index.js.map